import(/* webpackMode: "eager" */ "/home/claude/hadatha/hadatha/src/app/events/page.tsx");
